import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "errors text-white flex border-l-8 border-opacity-40 border-red-200 bg-red-600 bg-opacity-60 rounded-md px-2 py-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_ctx.hasErrors)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SvgIcon, {
          type: "mdi",
          path: _ctx.alertIcon,
          class: "mr-2 my-auto"
        }, null, 8, ["path"]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(error), 1))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}